module.exports = __webpack_public_path__ + "static/media/floret-media.51451077.png";